const styles = {
  mainArea: {
    minHeight: "100vh",
    paddingTop: 64,
  },
  relatedPanel: {
    backgroundColor: "white",
  },
};
export default styles;
